import { render, staticRenderFns } from "./button-loader.vue?vue&type=template&id=0a74508f"
import script from "./button-loader.vue?vue&type=script&lang=js"
export * from "./button-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a74508f')) {
      api.createRecord('0a74508f', component.options)
    } else {
      api.reload('0a74508f', component.options)
    }
    module.hot.accept("./button-loader.vue?vue&type=template&id=0a74508f", function () {
      api.rerender('0a74508f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/button-loader.vue"
export default component.exports